import { convertStylesToStyled } from '@/_utils/utils';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

type TypeLabelProps = {
  label: string;
  color: 'orange' | 'blue' | 'teal' | 'purple' | 'pink' | 'green' | 'lavender' | 'gray';
  icon: ReactNode;
  style?: React.CSSProperties;
};

const TypeLabel = ({ label = '', color = 'blue', icon, style, ...props }: TypeLabelProps) => (
  <Wrapper color={color} style={style} {...props}>
    <Icon>{icon}</Icon>
    <Label>{label}</Label>
  </Wrapper>
);

export default TypeLabel;

const typeLabelColorPresets = {
  orange: {
    background: '#FF7D032a',
    color: '#FF7D03',
    borderColor: '#FF7D03'
  },
  blue: {
    background: '#3F87EB2a',
    color: '#3F87EB',
    borderColor: '#3F87EB'
  },
  teal: {
    background: '#009FA82a',
    color: '#009FA8',
    borderColor: '#009FA8'
  },
  purple: {
    background: '#8855ee2a',
    color: '#8855ee',
    borderColor: '#8855ee'
  },
  pink: {
    background: '#C73DDD2a',
    color: '#C73DDD',
    borderColor: '#C73DDD'
  },
  green: {
    background: '#2AA4362a',
    color: '#2AA436',
    borderColor: '#2AA436'
  },
  lavender: {
    background: '#A886EF2a',
    color: '#A3A1FD',
    borderColor: '#A3A1FD'
  },
  gray: {
    background: '#5555553a',
    color: '#757575',
    borderColor: '#757575'
  }
};

export const typeLabelColorPresetKeys = Object.keys(typeLabelColorPresets);

const Wrapper = styled.div<{ color: TypeLabelProps['color'] }>`
  background: ${({ theme }) => theme.palette.background.default};
  display: inline-flex;
  align-items: center;
  border-radius: 3px;
  text-transform: uppercase;
  font-size: 0.9rem;
  white-space: nowrap;
  height: 2rem;
  border-style: ${({ theme }) => (theme.palette.mode === 'light' ? 'solid' : 'none')};
  border-width: ${({ theme }) => (theme.palette.mode === 'light' ? '1px' : '0')};

  ${({ color }) =>
    convertStylesToStyled(
      typeLabelColorPresetKeys.includes(color) ? typeLabelColorPresets[color as keyof typeof typeLabelColorPresets] : typeLabelColorPresets['gray']
    )}
`;

const Icon = styled.span`
  margin-right: ${({ theme }) => theme.spacing(0.75)};
  padding: ${({ theme }) => theme.spacing(0.75, 0, 0.75, 1.25)};

  & svg {
    display: block;
  }
`;

const Label = styled.span`
  display: flex;
  font-size: 0.9rem;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(0.75, 1.25, 0.75, 0)};
`;
